module.exports = __webpack_public_path__ + "img/config_google.f819ceeb.svg";